// extracted by mini-css-extract-plugin
export var completionBody = "_db-2";
export var completionCard = "_db-0";
export var completionFooter = "_db-3";
export var completionTitle = "_db-1";